import { Text } from 'foundations-components/components/Text';
import { getRecurringBillingFrequency } from 'payments-checkout-lib/utils/recurring';
import FormattedPrice from 'payments-checkout-lib/components/Utilities/FormattedPrice';
import { jsx as _jsx } from "react/jsx-runtime";
const LineItemPrice = ({
  currencyCode,
  lineItem,
  isBuyerOverridesLoading = false
}) => /*#__PURE__*/_jsx(Text, {
  "data-test-id": "line-item-amount",
  color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default',
  children: /*#__PURE__*/_jsx(FormattedPrice, {
    currencyCode: currencyCode,
    price: lineItem.amountBeforeTax || lineItem.amount,
    frequency: getRecurringBillingFrequency(lineItem.recurringBillingTerms),
    currencyAndAmountStyle: {
      typography: 'body-125',
      color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
    }
  })
});
export default LineItemPrice;